import { useEffect, useState } from 'react'

/**
 * App-wide “something is happening” signal for the doggos mark.
 * Import, chat send, and other short tasks call begin/end or pulse.
 */

const listeners = new Set()
let count = 0

function emit() {
  const active = count > 0
  listeners.forEach((fn) => {
    try {
      fn(active)
    } catch {
      /* ignore */
    }
  })
}

export function beginAppActivity() {
  count += 1
  emit()
  let stopped = false
  return () => {
    if (stopped) return
    stopped = true
    count = Math.max(0, count - 1)
    emit()
  }
}

export function pulseAppActivity(ms = 800) {
  const stop = beginAppActivity()
  if (typeof window === 'undefined') {
    stop()
    return
  }
  window.setTimeout(stop, ms)
}

export function subscribeAppActivity(fn) {
  listeners.add(fn)
  fn(count > 0)
  return () => listeners.delete(fn)
}

export function useAppActivity() {
  const [active, setActive] = useState(false)
  useEffect(() => subscribeAppActivity(setActive), [])
  return active
}
